import SequencesPage from "@/app/flows/sequences/pages/SequencesPage.vue";
import SequencesListTemplate from "@/app/flows/sequences/templates/SequencesListTemplate.vue";
import SequenceDetailTemplate from "@/app/flows/sequences/templates/SequenceDetailTemplate.vue";

export default [
  {
    path: "sequences",
    component: SequencesPage,
    meta: {
      requiresAuth: true,
    },
    children: [
      {
        path: "",
        component: SequencesListTemplate,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: ":id",
        component: SequenceDetailTemplate,
        meta: {
          requiresAuth: true,
        },
      },
    ],
  },
];
